import React, { FC } from 'react';
import { PageFooter } from 'components';
import {
  FuelTypography,
  FuelButton,
  FuelDivider,
  FuelSign,
  FuelInteractiveIcon,
} from '@frete.com/fuel-react';
import { Template, Wrapper, TextWrapper, Heading } from './styled';
import { useFunctions } from './functions';

const VerificationSuccess: FC = () => {
  const { handleCancel, handleNextStep, handleNewFreight } = useFunctions();

  return (
    <Template>
      <Heading>
        <FuelInteractiveIcon
          data-testid="clone-button"
          icon="close"
          onClick={handleCancel}
        />
      </Heading>
      <Wrapper>
        <FuelSign icon="double-check" color="green" size="medium" />
        <TextWrapper>
          <FuelTypography size="heading-lg" weight="bold">
            Frete postado com sucesso!
          </FuelTypography>
          <FuelTypography
            size="body-lg"
            weight="regular"
            color="neutral-default"
          >
            Realizaremos uma validação interna. Em caso de inconsistências nos
            dados seu frete poderá ser bloqueado.
          </FuelTypography>
        </TextWrapper>
      </Wrapper>

      <PageFooter disableStepsSwitcher>
        <FuelDivider />
        <FuelButton
          onClick={handleNewFreight}
          type="button"
          variant="tertiary"
          size="medium"
        >
          Cadastrar novo frete
        </FuelButton>
        <FuelButton
          type="button"
          variant="primary"
          size="medium"
          trailingIcon="one-check"
          onClick={handleNextStep}
        >
          Concluir
        </FuelButton>
      </PageFooter>
    </Template>
  );
};

export default VerificationSuccess;
